// Owner dashboard headline counters — active passes / total stamps /
// active customers. TanStack stale-while-revalidate at 60s so refresh
// thrash (tab-switching, route changes) doesn't re-hit the API on every
// render. Three indexed COUNTs server-side; cheap, but no reason to query
// twice a minute.

import { useQuery } from '@tanstack/react-query'

import { ownerApi } from '../ownerApi.js'

export interface DashboardStats {
  stamps_today: number
  total_stamps: number
  active_passes: number
  active_customers: number
}

export const dashboardStatsKey = ['owner', 'dashboard', 'stats'] as const

export function useDashboardStats() {
  return useQuery<DashboardStats>({
    queryKey: dashboardStatsKey,
    queryFn: () => ownerApi.get<DashboardStats>('/owner/dashboard/stats'),
    staleTime: 60_000,
  })
}
